<template src="./Companies.html"></template>

<script>
import { getCompanies } from '../../../services'

export default {
  name: 'Companies',
  props: {
    value: [String, Object],
    change: Function,
    focus: Boolean,
    isRequired: Boolean,
    returnObject: {
      type: Boolean,
      default: false
    },
    compliance: {
      type: Boolean,
      default: false
    },
    onlyActive: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: [String, Object],
      default: null
    }
  },
  model: {
    prop: 'value',
    event: 'update'
  },
  data: () => ({
    companies: [],
    rules: []
  }),
  created() {
    this.listCompany()
  },
  mounted() {
    if (this.focus) this.$refs.companies.$refs.input.focus()
    if (this.isRequired) this.rules = [(val) => !!val]
  },
  methods: {
    async listCompany() {
      try {
        const companies = await getCompanies()
        this.companies = this.onlyActive ? companies.filter(c => c.active) : companies
        if (this.defaultValue) {
          const id = typeof this.defaultValue === 'object' && this.defaultValue.id
            ? this.defaultValue.id
            : this.defaultValue;
          const found = this.companies.find(c => c.id === id);
          if (found) {
            const value = this.returnObject ? found : found.id;
            this.$emit('update', value);
            this.changeValue(value);
          }
        }

        if (!this.compliance && this.companies.length === 1 && !this.defaultValue) {
          this.$emit('update', this.companies[0].id)
          this.changeValue(this.companies[0].id)
        }
      } catch (err) {
        console.log('List companies:', err)
      }
    },
    changeValue(e) {
      if (this.change) this.change(e)
    }
  }
}
</script>
